import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

import pt from 'vuetify/lib/locale/pt'
import { runtimeConfig } from '@/config/runtimeConfig'

Vue.use(Vuetify)

const opts = {
	customProperties: true,
	icons: {
		iconfont: 'mdi',
	},
	theme: {
		themes: {
			light: {
				primary: runtimeConfig.theme.primary,
				secondary: runtimeConfig.theme.secondary,
				accent: "#12121e",
				backgroundOryx: "#f4f3ef"
			},
		},
	},
	lang: {
		locales: { pt }
	}
}

export default new Vuetify(opts)